'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@pixi/core');

function createTexture(base, loader, url) {
  const texture = new core.Texture(base);
  texture.baseTexture.on("dispose", () => {
    delete loader.promiseCache[url];
  });
  return texture;
}

exports.createTexture = createTexture;
//# sourceMappingURL=createTexture.js.map
